<div class="editor">
  <div class="editor-menu" [class.editor-menu-hidden]="hideMenu()">
    <ng-content select="[editorMenu]"></ng-content>
  </div>

  <div class="editor-main-container">
    @if (showSubmenu()) {
      <div class="editor-submenu-container">
        <div class="editor-submenu">
          <ng-content select="[editorSubmenu]"></ng-content>
        </div>
      </div>
    }

    <div class="editor-workspace">
      <ng-content select="[editorWorkspace]"></ng-content>
    </div>
  </div>
</div>

@if (showOverlay()) {
  <div class="editor-overlay">
    <lib-spinner size="lg" variant="accent" />
  </div>
}
